"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskEditModalButton = TaskEditModalButton;
exports.TaskAddNewModalButton = TaskAddNewModalButton;
const react_1 = __importDefault(require("react"));
const TaskGlobalModalBody_1 = require("./TaskGlobalModalBody");
const GeneralModalButtons_1 = require("../../View/Modals/GeneralModalButtons");
const TaskGlobalValidationSchema_1 = require("./TaskGlobalValidationSchema");
const TasksGlobalController_1 = require("../TasksGlobalController");
/** przycisk i modal edycji Task */
function TaskEditModalButton({ modalProps: { onEdit, initialData, repository }, buttonProps, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: TaskGlobalModalBody_1.TaskGlobalModalBody,
            modalTitle: "Edycja zadania",
            // repo z FilterableTable (scrum ma własne) — tam ustawiane są currentItems z id
            repository: repository ?? TasksGlobalController_1.tasksGlobalRepository,
            initialData: initialData,
            makeValidationSchema: TaskGlobalValidationSchema_1.makeTaskGlobalValidationSchema,
        }, buttonProps: {
            ...buttonProps,
            buttonVariant: "outline-success",
        } }));
}
function TaskAddNewModalButton({ modalProps: { onAddNew, contextData } }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            ModalBodyComponent: TaskGlobalModalBody_1.TaskGlobalModalBody,
            contextData,
            modalTitle: "Dodaj zadanie",
            repository: TasksGlobalController_1.tasksGlobalRepository,
            makeValidationSchema: TaskGlobalValidationSchema_1.makeTaskGlobalValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj zadanie",
            buttonVariant: "outline-success",
        } }));
}
